import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { LikelihoodDirections } from '@app/dp-shared/_enum/likelihood-direction/types';
import { QuaiManager_DropDownCaret } from '@app/styles';
export const Props_LikelihoodDirectionDropDown = {
    adapter: () => SimpleListAdapter([...LikelihoodDirections], dir => _jsx(_Fragment, { children: dir.item })),
    placeholder: 'Pick Likelihood Direction',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_LikelihoodDirection = TS_DropDown.prepare(Props_LikelihoodDirectionDropDown);
//# sourceMappingURL=ui-components.js.map